var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoBinamik = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102.932,
    height: 31.232,
    viewBox: "0 0 102.932 31.232",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2d2d2d;}.b{fill:#1ed6bb;}.b,.c{stroke:#005670;stroke-miterlimit:10;stroke-width:0.3px;}.c{fill:#005670;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-433.104 -125.887)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(458.454 133.139)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M555.888,164.914a5.711,5.711,0,0,0-3.239,1v-5.743h-2.834v15.9h2.834v-.689a5.738,5.738,0,1,0,3.239-10.474Zm0,8.661a2.923,2.923,0,1,1,2.923-2.923A2.923,2.923,0,0,1,555.888,173.575Z",
    transform: "translate(-549.815 -159.909)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M695.9,182.575v.688a5.738,5.738,0,1,0,0,9.431v.688h2.834V182.575ZM692.63,190.9a2.923,2.923,0,1,1,2.923-2.923A2.923,2.923,0,0,1,692.63,190.9Z",
    transform: "translate(-657.313 -177.215)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M609.67,160.773a1.773,1.773,0,0,1,.527-1.285,1.717,1.717,0,0,1,1.274-.538,1.736,1.736,0,0,1,1.274.527,1.763,1.763,0,0,1,.527,1.3,1.711,1.711,0,0,1-.527,1.252,1.8,1.8,0,0,1-2.548,0A1.711,1.711,0,0,1,609.67,160.773Zm3.273,14.345h-2.922V164.31h2.922Z",
    transform: "translate(-596.754 -158.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M637.307,187.343v6.217h-2.922V182.751h2.834v1.34a3.016,3.016,0,0,1,1.318-1.208,4.066,4.066,0,0,1,1.8-.417,3.577,3.577,0,0,1,2.911,1.2,4.655,4.655,0,0,1,1,3.086v6.81h-2.922v-6.3a2.356,2.356,0,0,0-.494-1.559,2.108,2.108,0,0,0-2.977.044A2.368,2.368,0,0,0,637.307,187.343Z",
    transform: "translate(-616.136 -177.392)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M754.116,193.479h-2.922V182.671h2.79v1.318A2.915,2.915,0,0,1,755.3,182.8a4.165,4.165,0,0,1,1.845-.439,3.219,3.219,0,0,1,3.207,1.8,3.822,3.822,0,0,1,3.427-1.8,3.734,3.734,0,0,1,3.91,4.108v7.008h-2.834v-6.414a2.224,2.224,0,0,0-.472-1.483,1.777,1.777,0,0,0-1.439-.56,1.85,1.85,0,0,0-1.45.615,2.193,2.193,0,0,0-.549,1.516v6.327h-2.9v-6.414a2.192,2.192,0,0,0-.483-1.483,1.783,1.783,0,0,0-1.428-.56,1.892,1.892,0,0,0-1.472.6,2.183,2.183,0,0,0-.549,1.527Z",
    transform: "translate(-707.74 -177.312)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M835.669,160.773a1.774,1.774,0,0,1,.527-1.285,1.718,1.718,0,0,1,1.274-.538,1.736,1.736,0,0,1,1.274.527,1.761,1.761,0,0,1,.527,1.3,1.71,1.71,0,0,1-.527,1.252,1.8,1.8,0,0,1-2.548,0A1.711,1.711,0,0,1,835.669,160.773Zm3.273,14.345h-2.922V164.31h2.922Z",
    transform: "translate(-773.987 -158.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M860.383,170.7v13.631H863.3v-2.856l1.208-1.274,2.856,4.13h3.581l-4.415-6.261,4.327-4.547h-3.822l-3.734,4.02V170.7Z",
    transform: "translate(-793.368 -168.167)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(433.316 126.037)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M468.679,138.571l3.913-3.913-3.913-3.913,3.694-3.694,7.607,7.607-7.607,7.607Z",
    transform: "translate(-461.048 -126.832)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M468.679,209.078l3.913-3.913-3.913-3.913,3.694-3.694,7.607,7.607-7.607,7.607Z",
    transform: "translate(-461.048 -182.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M452.467,133.863l-7.825-7.825h-7.413l-3.912,3.912,3.913,3.913-3.913,3.913,3.694,3.694-3.694,3.694,3.913,3.913-3.913,3.913,3.913,3.913h7.412l7.826-7.826-7.607-7.607Zm-7.607.219.066-.066h6.951l-7.236,7.236-3.476-3.475Zm.066-.371-.066-.066-3.694-3.694,3.476-3.476,7.236,7.236Zm-3.991-3.967-3.4-3.4h6.8Zm0,8.239,3.487,3.487-3.487,3.487-3.487-3.487Zm-7.182-.207,3.694-3.694.219-.219-.219-.219-3.694-3.694,3.476-3.476,7.389,7.388-7.389,7.389h0Zm3.476,18.69-3.476-3.476,3.694-3.694.219-.219-.219-.219-3.694-3.694,3.476-3.476,7.389,7.388Zm.305.132,3.4-3.4,3.4,3.4Zm7.107-.132-3.476-3.476,3.694-3.694.066-.066h6.951Zm.284-7.542-.066-.066-3.694-3.694,3.476-3.476,7.235,7.235Z",
    transform: "translate(-433.316 -126.037)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoBinamik);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logoBinamik.4f67653eb22363387de1e109089d4fbc.svg";